/**
 * Batch D, item 12: the donor FAQ's search. Typing hides every question whose question and answer do not contain
 * all the words typed, hides a category with nothing left, and says so when nothing matches. Without script the whole
 * FAQ is shown and every answer still opens.
 */
( function () {
	'use strict';

	function init( faq ) {
		const search = faq.querySelector( '[data-anudan-faq-search]' );
		const none = faq.querySelector( '[data-anudan-faq-none]' );

		if ( ! search ) {
			return;
		}

		search.hidden = false;

		const label = faq.querySelector( '.anudan-faq__search-label' );

		if ( label ) {
			label.hidden = false;
		}

		search.addEventListener( 'input', () => {
			const words = search.value.toLowerCase().split( /\s+/ ).filter( Boolean );
			let shown = 0;

			faq.querySelectorAll( '[data-anudan-faq-group]' ).forEach( ( group ) => {
				let inGroup = 0;

				group.querySelectorAll( '[data-anudan-faq-item]' ).forEach( ( item ) => {
					const text = item.textContent.toLowerCase();
					const match = words.every( ( word ) => text.includes( word ) );

					item.hidden = ! match;
					inGroup += match ? 1 : 0;
				} );

				group.hidden = 0 === inGroup;
				shown += inGroup;
			} );

			if ( none ) {
				none.hidden = shown > 0;
			}
		} );
	}

	function start() {
		document.querySelectorAll( '[data-anudan-faq]' ).forEach( init );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', start );
	} else {
		start();
	}
}() );
